module.exports = __webpack_public_path__ + "static/img/man.6eaa0e37.png";